export default defineNuxtRouteMiddleware(async to => {
  const { $store } = useNuxtApp();

  await $store.dispatch('strapi/getFeedbackByPath', { path: to.path });
});
